/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Github_UnlinkedInputs */



/**
* | output |
* | --- |
* | "GitHub account unlinked." |
*
* @param {Profile_Github_UnlinkedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_github_unlinked = /** @type {((inputs?: Profile_Github_UnlinkedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Github_UnlinkedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compte GitHub délié.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuenta de GitHub desvinculada.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Conta do GitHub desvinculada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Account GitHub scollegato.")
	return /** @type {LocalizedString} */ ("GitHub account unlinked.")
});